(ns web3.routers.policy-redirect
  (:require [re-frame.core :as rf]
            [re-frame-simple.db :as db]
            [web3.env :as env]
            [web3.log :as log :include-macros true]
            [web3.persistence.current-property :as current-property]
            [applied-science.js-interop :as j]))


(defn create-form
  [destination]
  (-> (j/call js/document :createElement "form")
      (j/assoc! :method "GET")
      (j/assoc! :action destination)))

(defn create-form-with-post
  [destination]
  (-> (j/call js/document :createElement "form")
      (j/assoc! :method "POST")
      (j/assoc! :action destination)))

(defn create-hidden-input
  [k v]
  (-> (j/call js/document :createElement "input")
      (j/assoc! :type "hidden")
      (j/assoc! :name k)
      (j/assoc! :value v)))

(defn redirect-to-policy!
  "Create an HTML form and submit it to avoid token in URL"
  [{:keys [access-token zip-code]}]
  (log/println :do/account.redirect-to-policy!-start)
  (let [destination        (str (:HOMESERVE_LANDING_URL env/config) "")
        form-to-post       (create-form destination)]
    ;(j/call form-to-post :appendChild (create-hidden-input "token" access-token))
    (when zip-code
      (j/call form-to-post :appendChild (create-hidden-input "zipcode" zip-code )))
    (j/call-in js/document [:body :appendChild] form-to-post)
    (j/call form-to-post :submit)))

(rf/reg-fx
  :redirect/homeserve-policy redirect-to-policy!)

(rf/reg-event-fx
  :do/redirect.policy
  [log/interceptor] ;; TODO look into putting the get-current-property call into cofx
  (fn []
    {:redirect/homeserve-policy
     {:access-token (db/get-in [:auth0/auth :access-token])
      :zip-code     (get-in (current-property/get-property) [:address :postalCode])}}))